<template>
  <div class="filter">
    <div class="filter_form">
      <div class="level bottom">
        <div class="level-left">
          <b-field class="input_checkbox">
            <b-checkbox @input="$emit('change')" v-model="search.trashed" type="is-info">
              Показать архивные
            </b-checkbox>
          </b-field>
        </div>
        <div class="level-right filter_actions">
          <button
            class="delete_branch"
            @click="$emit('delete-checked')"
            v-if="!search.trashed"
            :disabled="!rows.checked.length"
          >
            <i class="mdi mdi-folder-remove-outline"></i> В архив
          </button>
          <button class="delete_branch" @click="$emit('restore')" v-else :disabled="!rows.checked.length">
            <i class="mdi mdi-folder-remove-outline"></i> Восстановить
          </button>
          <button class="add_branch" @click="$emit('open-modal')">
            <i class="mdi mdi-folder-plus-outline"></i> Добавить филиал
          </button>
        </div>
      </div>
      <form class="level" @submit.prevent="$emit('change')">
        <b-field label="Поиск по названию филиала:" class="branch_search input_search with_button" type="is-info">
          <b-input placeholder="Поиск филиалов" v-model="search.name"></b-input>
          <button type="submit">Поиск</button>
        </b-field>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    search: {
      default: () => {},
      type: Object
    },
    rows: {
      default: () => {},
      type: Object
    }
  }
}
</script>
